import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import ColumnTarget from '../component/columnTarget';
import { Flex } from '@chakra-ui/react';

const tableListBrand = ({ targetMonth, t }) => {
  return [
    {
      name: t('table.brand.brand'),
      width: 150,
      key: 'brandName',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.targetGmv'),
      width: 200,
      key: 'targetGmv',
      sortKey: 'targetGmv',

      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetGmv')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
            .
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.gmv'),
      width: 200,
      key: 'actualGmv',
      sortKey: 'actualGmv',
      labelInfo: t('table.common.tooltipGmv'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementGmvPercentage} />,
    },
    {
      name: t('table.common.targetErr'),
      width: 140,
      key: 'targetErr',
      sortKey: 'targetErr',
      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetErr')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.err'),
      width: 150,
      key: 'actualErr',
      sortKey: 'actualErr',
      labelInfo: t('table.common.tooltipErr'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementErrPercentage} />,
    },
    {
      name: t('table.common.targetCtr'),
      width: 140,
      key: 'targetCtr',
      sortKey: 'targetCtr',
      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetCtr')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.ctr'),
      width: 150,
      key: 'actualCtr',
      sortKey: 'actualCtr',
      labelInfo: t('table.common.tooltipCtr'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementCtrPercentage} />,
    },
    {
      name: t('table.common.targetCtor'),
      width: 150,
      key: 'targetCtor',
      sortKey: 'targetCtor',
      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetCtor')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.ctor'),
      width: 150,
      key: 'actualCtor',
      sortKey: 'actualCtor',
      labelInfo: t('table.common.tooltipCtor'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementCtorPercentage} />,
    },
    {
      name: t('table.common.targetAov'),
      width: 200,
      key: 'targetAov',
      sortKey: 'targetAov',
      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetAov')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.aov'),
      width: 200,
      key: 'actualAov',
      sortKey: 'actualAov',
      labelInfo: t('table.common.tooltipAov'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementAovPercentage} />,
    },
    {
      name: t('table.common.targetViews'),
      width: 150,
      key: 'targetViews',
      sortKey: 'targetViews',
      labelInfo: (
        <Flex flexDirection={'column'} gap={'8px'} textAlign={'left'}>
          <TextMedium>{t('table.common.tooltipTargetViews')}</TextMedium>
          <TextMedium>
            {t('table.common.commmonTooltipReportFor', {
              targetMonth,
            })}
          </TextMedium>
        </Flex>
      ),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('table.common.views'),
      width: 150,
      key: 'actualViews',
      sortKey: 'actualViews',
      labelInfo: t('table.common.tooltipViews'),
      component: ({ value, values }) => <ColumnTarget achievement={value} target={values?.achievementViewsPercentage} />,
    },
    {
      name: t('table.common.awd'),
      width: 270,
      key: 'actualAwd',
      sortKey: 'actualAwd',
      labelInfo: t('table.common.tooltipAwd'),
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
  ];
};

export default tableListBrand;
